export enum LocalStorageEnum {
  UserToken = 'user-token',
}
